import styled from 'styled-components';

export const StyledVictoryCaptionEditor = styled.div`
  border: solid 2px ${({ theme, $focused }) => $focused ? 'white' : theme.inputBorder};
  width: 100%;
  background: ${({ theme }) => theme.buttonDark};
`;

export const StyledVictoryCaptionDecorator = styled.div`
  width: 100%;
  border: solid 2px ${({ theme }) => theme.buttonDark};
  height: 0.5rem;
  background: ${({ theme, $focused }) => $focused ? theme.buttonGreen : theme.selectionBlue};
`;

export const StyledVictoryCaptionControls = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  padding: 0.5rem 1rem;
`;

export const StyledControl = styled.div`
  cursor: pointer;
  width: 1rem;
  height: 1rem;

  img {
    width: 100%;
    height: 100%;
  }
`;

export const StyledEditControls = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
`;

export const StyledLimit = styled.div`
  font-family: "NeueMachina";
  color: white;
  font-size: 0.75rem;
`;

export const StyledVictoryCaptionText = styled.textarea`
  padding: 0.5rem 1rem;
  background: transparent;
  width: 100%;
  resize: none;
  border: none;
  outline: none;
  caret-color: white;
  font-family: "NeueMachina";
  font-size: 1rem;
  line-height: 1.4rem;
  color: white;
`;
